import { map } from 'rxjs/operators';
import { fetchCustomers, updateCustomer } from '../../../features/customer/redux/customerSlices';
import { CustomerDto } from '../../PricePrgClient';
import { hubListener, hubNotifier, signalROptions } from '../helpers';
import { notifyCustomerUpdated } from '../signalrActions';
import { SignalrHub } from '../signalrTypes';

export const customerHub: SignalrHub = {
    hubName: 'customer hub',
    url: '/signalr/customerHub',
    autoReconnect: true,
    options: signalROptions
};

const customerHub$ = hubListener(customerHub, hub => {
    const customersUpdated$ = hub.on<void>('CustomersUpdated').pipe(map(fetchCustomers.request));
    const customerUpdated$ = hub.on<CustomerDto>('CustomerUpdated').pipe(map(updateCustomer.success));
    return [customersUpdated$, customerUpdated$];
});

const notifyCustomerUpdated$ = hubNotifier(customerHub, notifyCustomerUpdated, (hub, payload) =>
    hub.send('NotifyCustomerUpdated', payload)
);

export default [customerHub$, notifyCustomerUpdated$];
